module.exports = __webpack_public_path__ + "assets/26af3d9e59305394e4aaf771c5187a2c.mp3";